import { PIXI } from '@colonist/pixi';
import { GameStateEnums } from '../../../../shared/GameEnums.ts';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { ClientUserState } from '../ClientUserState.ts';
export class UIGameResponsiveController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.BeginnerModeStart:
                this.onBeginnerModeStart();
                break;
            default:
                break;
        }
    }
    buildRenderer() {
        const size = this.getAppWnH();
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h);
        this.uiGameManager.canvasController.app.view.style.top = '50%';
        this.uiGameManager.canvasController.app.view.style.transform = 'translate(0%, -50%)';
        this.uiGameManager.canvasController.syncTooltipCanvas();
    }
    resizeScreen() {
        const shouldShowVerticalAds = this.showVerticalAds();
        if (shouldShowVerticalAds) {
            var _this_uiGameManager_adController;
            (_this_uiGameManager_adController = this.uiGameManager.adController) === null || _this_uiGameManager_adController === void 0 ? void 0 : _this_uiGameManager_adController.showInGameAds();
        } else {
            var _this_uiGameManager_adController1;
            (_this_uiGameManager_adController1 = this.uiGameManager.adController) === null || _this_uiGameManager_adController1 === void 0 ? void 0 : _this_uiGameManager_adController1.hideInGameAds();
        }
        this.isCanvasFullWidth = !shouldShowVerticalAds;
        this.resizeCanvas();
    }
    resizeCanvas() {
        const size = this.getAppWnH();
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h);
        this.uiGameManager.canvasController.app.view.style.left = this.getCanvasX() + 'px';
        this.uiGameManager.canvasController.setCanvasConfigVariables();
        this.uiGameManager.canvasController.resizeBackgroundSprite();
        this.uiGameManager.canvasController.syncTooltipCanvas();
        this.uiGameManager.eventController.sendEvent(undefined, UIGameEventEnums.CanvasResized);
        this.uiGameManager.resizeUIGame();
    }
    getCanvasY() {
        const view = this.uiGameManager.canvasController.app.view;
        return view.offsetTop - view.clientHeight / 2;
    }
    getCanvasX() {
        const adWidth = this.showVerticalAds() ? UIGameResponsiveController.getInGameVerticalAdWidth() : 0;
        const extraSpace = window.innerWidth - this.getAppWnH().w - adWidth * 2;
        return adWidth + extraSpace / 2;
    }
    showVerticalAds() {
        var _ClientUserState_userState;
        if (this.forceHideAds) return false;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds()) return false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (PIXI.utils.isMobile.phone) return false;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return false;
        if (document.fullscreenElement) return false;
        if (window.innerWidth > 1500) return true;
        if (window.innerWidth < window.innerHeight) return false;
        return true;
    }
    showHorizontalAds() {
        var _ClientUserState_userState;
        if ((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds()) return false;
        if (UIUtilsEjsVariables.isUserOnDiscord) return false;
        if (document.fullscreenElement) return false;
        if (window.innerHeight < 1000) return false;
        if (this.forceHideAds) return false;
        return true;
    }
    getAppWnH() {
        const maxRatio = 15 / 11;
        let w = this.showVerticalAds() ? window.innerWidth - UIGameResponsiveController.getInGameVerticalAdWidth() * 2 : window.innerWidth;
        let h = this.showHorizontalAds() ? window.innerHeight - UIGameResponsiveController.getInGameHorizontalAdHeight() : window.innerHeight;
        if (UIGameResponsiveController.isDeviceHorizontalAndHaveHomeIndicator()) h -= 15;
        if (UIGameResponsiveController.isDeviceMobileAndroid()) w -= 60;
        if (w / h >= maxRatio) return {
            w: w,
            h: h
        };
        return {
            w: w,
            h: w / maxRatio
        };
    }
    onBeginnerModeStart() {
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return;
        this.forceHideAds = true;
        this.resizeScreen();
    }
    static getInGameVerticalAdWidth() {
        const verticalAdWidth = 160;
        const margin = 5;
        const mobileZoom = 0.6;
        // if(uiManager.resonsiveController.isHorizontalMobile()) return verticalAdWidth * mobileZoom
        return verticalAdWidth + margin;
    }
    canShowBottomAd() {
        const bottomAdPadding = 5;
        const heightLeftForBottomAd = (window.innerHeight - this.getAppWnH().h) / 2 - bottomAdPadding * 1.5;
        return heightLeftForBottomAd >= UIGameResponsiveController.getInGameHorizontalAdHeight();
    }
    static getInGameHorizontalAdHeight() {
        return 90;
    }
    // private getInGameHorizontalAdWidth(): number {
    //     return 728
    // }
    static isDeviceHorizontalAndHaveHomeIndicator() {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
        const aspect = window.screen.width / window.screen.height;
        if (iPhone && aspect.toFixed(3) === '0.462') return true;
        return false;
    }
    static isDeviceMobileAndroid() {
        if (!UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return false;
        return /Android/i.test(navigator.userAgent);
    }
    // TODO: once the game is vertical, this should not be used
    static get resolutionScale() {
        return UIUtilsEjsVariables.isUserOnMobileAppOrWeb ? 2 : 1;
    }
    static set resolutionScale(value) {
        UIGameResponsiveController._resolutionScale = value;
    }
    getScaleForRotation() {
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) {
            return window.innerWidth / this.uiGameManager.canvasController.appW;
        }
        return 1;
    }
    constructor(uiGameManager){
        this.forceHideAds = false;
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.isCanvasFullWidth = !this.showVerticalAds();
    }
}
UIGameResponsiveController._resolutionScale = 1;
